if (!customElements.get("cheeky-review-preview")) {
  class CheekyReviewPreview extends HTMLElement {
    constructor() {
      super();
      this.isOpen = true;
      this.reviews = [];
    }

    async connectedCallback() {
      // Initial render with loading state
      this.innerHTML = `
        <div class="dropdown-menu reviews-preview active">
          <div class="dropdown-title">
            <span>Review Highlights</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_1757_930)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 8C0.5 3.858 3.858 0.5 8 0.5C12.142 0.5 15.5 3.858 15.5 8C15.5 12.142 12.142 15.5 8 15.5C3.858 15.5 0.5 12.142 0.5 8ZM6.71867 11.2733C6.73367 11.6137 6.94233 11.9033 7.27967 11.9527C7.465 11.9797 7.703 12 8 12C8.297 12 8.535 11.9797 8.72033 11.9527C9.05767 11.9033 9.26633 11.6137 9.28133 11.2733C9.298 10.8887 9.31733 10.2703 9.327 9.327C10.2703 9.31733 10.8887 9.29833 11.2733 9.28133C11.6137 9.26633 11.9033 9.05767 11.9527 8.72033C11.9797 8.535 12 8.297 12 8C12 7.703 11.9797 7.465 11.9527 7.27967C11.9033 6.94233 11.6137 6.73367 11.2733 6.71867C10.8887 6.702 10.2703 6.68267 9.327 6.673C9.31733 5.72967 9.29833 5.11133 9.28133 4.72667C9.26633 4.38633 9.05767 4.09667 8.72033 4.04733C8.48168 4.01423 8.24094 3.99841 8 4C7.703 4 7.465 4.02033 7.27967 4.04733C6.94233 4.09667 6.73367 4.38633 6.71867 4.72667C6.702 5.11133 6.68267 5.72967 6.673 6.673C5.72967 6.68267 5.11133 6.70167 4.72667 6.71867C4.38633 6.73367 4.09667 6.94233 4.04733 7.27967C4.01423 7.51833 3.99841 7.75906 4 8C4 8.297 4.02033 8.535 4.04733 8.72033C4.09667 9.05767 4.38633 9.26633 4.72667 9.28133C5.11133 9.298 5.72967 9.31733 6.673 9.327C6.68267 10.2703 6.70167 10.8887 6.71867 11.2733Z" fill="#1E2815"/>
              </g>
              <defs>
              <clipPath id="clip0_1757_930">
              <rect width="16" height="16" fill="white"/>
              </clipPath>
              </defs>
            </svg>
          </div>
          <div class="dropdown-content" style="max-height: none;">
            <div class="reviews-container">
              <div class="loading">Loading reviews...</div>
            </div>
          </div>
        </div>
      `;

      // Add rotated class to icon initially
      const icon = this.querySelector(".dropdown-title svg");
      icon.classList.add("rotated");

      this.querySelector(".dropdown-title").addEventListener("click", () =>
        this.toggle()
      );
      // Get product data from the page
      const productID =
        document.querySelector("[data-product-id]").dataset.productId;
      if (productID) {
        await this.fetchReviews("lofi-lavender", productID);
      }
    }

    async fetchReviews(handle, external_id) {
      try {
        const response = await fetch(
          `https://judge.me/api/v1/widgets/product_review?api_token=4gTh7gcSvvHxMRB5-X7l6Zxb3zc&shop_domain=cheeky-soap.myshopify.com&handle=${handle}&external_id=${external_id}&per_page=30`
        );
        const data = await response.json();

        // Parse the HTML response to get reviews
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = data.widget;

        // Extract reviews from the widget HTML
        const reviewElements = tempDiv.querySelectorAll(".jdgm-rev");
        let lastReviewAuthor = ''
        let reviews = Array.from(reviewElements)
          .map((el) => ({
            rating: el
              .querySelector(".jdgm-rev__rating")
              ?.getAttribute("data-score"),
            title:
              el.querySelector(".jdgm-rev__title")?.textContent?.trim() || "",
            body:
              el.querySelector(".jdgm-rev__body p")?.textContent?.trim() || "",
            author:
              el.querySelector(".jdgm-rev__author")?.textContent?.trim() || "",
            verifiedBuyer: el.getAttribute("data-verified-buyer") === "true",
          }))
          .filter((review) => {
            if (data.widget.includes("soap-tray") || data.widget.includes("soap-bags")) {
              if (review.rating === "5" && review.body.length > 15) {
                lastReviewAuthor = review.author;
                return true;
              }
            } else {
              if (review.rating === "5" && review.body.length > 100) {
                if (review.author !== lastReviewAuthor) {
                  lastReviewAuthor = review.author;
                  return true;
                }
              }
            }
            
          }
          )
          .slice(0, 3);

        if (!window.location.href.includes('soap-tray') && !window.location.href.includes('soap-bags')) {
          // reviews = [
          //   {
          //     body: "I used to use the bigfoot brand (you know which one) and the scents didn't last nearly as long as Cheeky. Not to mention I have a fresh tattoo just a few weeks old, and the other brands would leave the surrounding skin very noticeably dry and flakey but after using Cheeky I see no flakes and no dry patches. Much better quality in every aspect, Charlie has earned a lifetime buyer out of me.",
          //     author: "Jon H.",
          //     title: "Lifetime buyer"
          //   },
          //   {
          //     body: "Just got my box today(2 days after ordering with normal delivery, hell yeah). Tried Pulp Francis first. The scents are strong but not overpowering. It goes on silky smooth and I don't know if my skin has ever felt THIS smooth fresh out of the shower with no lotion. Price point is perfect for the product. The boys just made a lifetime customer out of me lol. TL/DR: this soap is bomb af!",
          //     author: "Ayana M.",
          //     title: "Just buy the damn soap!!"
          //   },
          //   {
          //     body: `Writing this review about Spoap. Bought the 8 bar deal plus soap tray. soap box art? fire. soap tray size and design? fire. Scents? Simply Amazing. Just used my first ever bar and chose Spoap (<3). moisturizing, smooth feeling post shower, amazing scent. As Louis Armstrong once said.... "What a wonderful world". Thank you Team Moist.`,
          //     author: "Trey",
          //     title: "spoap love is real god damn it."
          //   }
          // ]
        }

        if (reviews.length > 0) {
          this.renderReviews(reviews);
        } else {
          this.hideReviewSection();
        }
      } catch (error) {
        console.error("Error fetching reviews:", error);
        this.hideReviewSection();
      }
    }



    renderReviews(reviews) {
      const reviewsHtml = reviews
        .map(
          (review) => `
        <div class="review-item">
          <div class="review-stars">
            <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
          </div>
          <p class="review-title">${review.title ? `${review.title} - ` : ""}${
            review.author
          }</p>
          <p class="review-text" data-full-review="${this.escapeHtml(
            review.body
          )}">
            ${this.truncateText(review.body, 150)}
            ${
              review.body.length > 150
                ? '<span class="continue-reading">Continue Reading</span>'
                : ""
            }
          </p>
        </div>
      `
        )
        .join("");

      const container = this.querySelector(".reviews-container");
      container.innerHTML = `
        ${reviewsHtml}
        ${
          window.location.pathname === "/"
            ? ""
            : '<a href="#judgeme_product_reviews" class="button reviews-button">Read More Reviews</a>'
        }
      `;

      // Add click handlers for continue reading buttons
      this.querySelectorAll(".continue-reading").forEach((button) => {
        button.addEventListener("click", (e) => {
          e.stopPropagation();
          const reviewText = e.target.closest(".review-text");
          const fullReview = reviewText.getAttribute("data-full-review");
          reviewText.innerHTML = fullReview;
        });
      });
    }

    hideReviewSection() {
      this.style.display = "none";
    }

    truncateText(text, limit) {
      if (text.length <= limit) return this.escapeHtml(text);
      return this.escapeHtml(text.slice(0, limit) + "...");
    }

    escapeHtml(unsafe) {
      return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    toggle() {
      this.isOpen = !this.isOpen;
      const content = this.querySelector(".dropdown-content");
      const icon = this.querySelector(".dropdown-title svg");
      const reviewsPreview = this.querySelector(".reviews-preview");

      content.style.maxHeight = this.isOpen ? `${content.scrollHeight}px` : "0";
      icon.classList.toggle("rotated", this.isOpen);
      reviewsPreview.classList.toggle("active", this.isOpen);
    }
  }

  customElements.define("cheeky-review-preview", CheekyReviewPreview);

  class CheekyDropdown extends HTMLElement {
    constructor() {
      super();
      this.isOpen = false;
    }

    connectedCallback() {
      const title = this.getAttribute("title");
      this.innerHTML = `
        <div class="dropdown-menu">
          <div class="dropdown-title">
            <span>${title}</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_1757_930)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 8C0.5 3.858 3.858 0.5 8 0.5C12.142 0.5 15.5 3.858 15.5 8C15.5 12.142 12.142 15.5 8 15.5C3.858 15.5 0.5 12.142 0.5 8ZM6.71867 11.2733C6.73367 11.6137 6.94233 11.9033 7.27967 11.9527C7.465 11.9797 7.703 12 8 12C8.297 12 8.535 11.9797 8.72033 11.9527C9.05767 11.9033 9.26633 11.6137 9.28133 11.2733C9.298 10.8887 9.31733 10.2703 9.327 9.327C10.2703 9.31733 10.8887 9.29833 11.2733 9.28133C11.6137 9.26633 11.9033 9.05767 11.9527 8.72033C11.9797 8.535 12 8.297 12 8C12 7.703 11.9797 7.465 11.9527 7.27967C11.9033 6.94233 11.6137 6.73367 11.2733 6.71867C10.8887 6.702 10.2703 6.68267 9.327 6.673C9.31733 5.72967 9.29833 5.11133 9.28133 4.72667C9.26633 4.38633 9.05767 4.09667 8.72033 4.04733C8.48168 4.01423 8.24094 3.99841 8 4C7.703 4 7.465 4.02033 7.27967 4.04733C6.94233 4.09667 6.73367 4.38633 6.71867 4.72667C6.702 5.11133 6.68267 5.72967 6.673 6.673C5.72967 6.68267 5.11133 6.70167 4.72667 6.71867C4.38633 6.73367 4.09667 6.94233 4.04733 7.27967C4.01423 7.51833 3.99841 7.75906 4 8C4 8.297 4.02033 8.535 4.04733 8.72033C4.09667 9.05767 4.38633 9.26633 4.72667 9.28133C5.11133 9.298 5.72967 9.31733 6.673 9.327C6.68267 10.2703 6.70167 10.8887 6.71867 11.2733Z" fill="#1E2815"/>
              </g>
              <defs>
              <clipPath id="clip0_1757_930">
              <rect width="16" height="16" fill="white"/>
              </clipPath>
              </defs>
            </svg>
          </div>
          <div class="dropdown-content">
            ${this.innerHTML}
          </div>
        </div>
      `;

      this.querySelector(".dropdown-title").addEventListener("click", () =>
        this.toggle()
      );
    }

    toggle() {
      this.isOpen = !this.isOpen;
      const content = this.querySelector(".dropdown-content");
      const icon = this.querySelector(".dropdown-title svg");

      content.style.maxHeight = this.isOpen ? `${content.scrollHeight}px` : "0";
      icon.classList.toggle("rotated", this.isOpen);
    }
  }

  customElements.define("cheeky-dropdown", CheekyDropdown);
}
